export const MAPS_API_KEY = 'AIzaSyDSOLxTZy_56sksxVCD970SpqJPFxXe5Ok'
